import React, { Component, Fragment } from "react";
import CountUp from "react-countup";

import { findMinMax, label, sortFunctionByValue, color } from "utils";

// Composant graphique pour afficher un Histogram horizontal.
class HorizontalHistogram extends Component {
  constructor(props) {
    super(props);

    this.state = {
      data: [],
      active: false,
    };
  }

  static getDerivedStateFromProps(nextProps, prevState) {
    if (nextProps.refreshes === prevState.refreshes || !nextProps.data) return null;

    var sum = nextProps.data.reduce((a, b) => a + b.value, 0);
    var data = (nextProps.data || []).map((d) => ({
      ...d,
      perc: parseInt((d.value / sum) * 100),
    }));

    data = nextProps.sort === false ? data : data.sort((a, b) => sortFunctionByValue(a, b, false));

    return {
      data,
      refreshes: nextProps.refreshes,
    };
  }

  render() {
    const { data, active } = this.state;
    const { perc } = this.props;

    return (
      <ul className="horiz-histo-wrap" onMouseOut={() => this.setState({ active: false })}>
        {data.map((d, i) => (
          <li
            key={i}
            onMouseOver={() => this.setState({ active: i })}
            className={active !== false ? (i === active ? "hovered" : "not-hovered") : ""}
          >
            <span className="histo-label">
              <b>{d.label}</b>
              {perc ? (
                <CountUp separator=" " decimal="," end={d.perc} preserveValue suffix="%" />
              ) : (
                <CountUp separator=" " decimal="," end={d.value} preserveValue />
              )}
            </span>

            <span className="histo-bar">
              <span
                className="histo-bar-fill"
                style={{
                  width: `${d.perc}%`,
                  background: color(this.props.colorIndex || 0, d.label),
                }}
              ></span>
            </span>
          </li>
        ))}
      </ul>
    );
  }
}

export default HorizontalHistogram;
